"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectionReplacedLine = connectionReplacedLine;
/**
 * What Banks says after a re-link of the same login replaced an earlier connection
 * (BEN-141 FP-109, reading B phase 1).
 *
 * Paul (2026-10-06): "move goals, debts and categories to the matching new accounts,
 * and say so on Banks. Announce automatically, don't ask." The server moves goals
 * and debts (`apps.banking.supersede`) and reports the counts on the new connection's accounts
 * as `connection_replaced` for 30 days. Only what actually moved is named; a re-link
 * that moved nothing still says the connection was replaced, because the earlier
 * one disappeared from Banks and the user did not do that themselves.
 *
 * Categories are not named: whether a re-linked row keeps its old category is Paul's
 * call (2026-10-06, open), and the sentence about them is agreed with mobile once it
 * is made.
 */
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
function connectionReplacedLine(args) {
    const { bank, goals, debts } = args;
    const lines = [`We replaced your earlier ${bank} connection with this one.`];
    const moved = [
        goals > 0 ? plural(goals, "goal", "goals") : "",
        debts > 0 ? plural(debts, "debt", "debts") : "",
    ].filter(Boolean);
    if (moved.length)
        lines.push(`${moved.join(" and ")} moved with it.`);
    return lines.join(" ");
}
//# sourceMappingURL=connectionReplacedCopy.js.map